const theme = {
  colors: {
    primary: '#3699CF',
    primary_gradient: '#7f99CF',
    secondary: '#D65D5D',

    icon: '#1378AF',
    
    green: '#21D0A1',
    dark_green: '#00c070',
   
    text: '#272E47',
    white: '#FFF',
    gray: '#F3F4F7',

    medium_gray: '#DBDFEB',
    validatedBorder: '#8FE7D0',
    placeholder: '#B7BFC9',
    disabledBg: '#f4f5f8',

    invalidatedBadge: '#FE726E'
  }
}

export default theme;